import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { PrimeIcons } from "primereact/api";

import { useAppDispatch, useAppSelector } from "store/store";
import { inputState, labelAperta, labelArchiviata } from "_constants";
import { Controller, useForm } from "react-hook-form";
import { setReportsState } from "store/slicer/GestioneReportSlice";

export const InputStateFilter = () => {
  const { control, setValue } = useForm({
    defaultValues: {
      state: "",
    },
    mode: "onChange",
  });
  const dispatch = useAppDispatch();
  const state = useAppSelector(
    (state) => state.gestioneReportSlice.filters.state
  );

  const stateOptions = [
    { name: labelAperta, value: "APERTA" },
    { name: labelArchiviata, value: "ARCHIVIATA" },
  ];

  const onChangeValue = (event: DropdownChangeEvent) => {
    if (event.value) {
      setValue("state", event.value);
      dispatch(setReportsState(event.value));
    } else {
      setValue("state", "");
      dispatch(setReportsState(null));
    }
  };

  return (
    <Controller
      name="state"
      control={control}
      render={({ field }) => (
        <Dropdown
          dataKey="state"
          id={field.name}
          {...field}
          onChange={onChangeValue}
          options={stateOptions}
          optionLabel="name"
          optionValue="value"
          placeholder={inputState}
          aria-label={inputState}
          clearIcon={PrimeIcons.TIMES}
          showClear={state !== null}
        />
      )}
    />
  );
};
